import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    nights_stay: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.1 12.08C11.05 12.05 11 12.03 11 12c0-.55-.45-1-1-1s-1 .45-1 1c0 .05-.05.08-.1.08-.55 0-1 .45-1 1s.45 1 1 1c.05 0 .1.03.1.08 0 .55.45 1 1 1s1-.45 1-1c0-.05.05-.08.1-.08.55 0 1-.45 1-1s-.45-1-1-1zM14 2c1.82 0 3.53.5 5 1.35-2.99 1.73-5 4.95-5 8.65s2.01 6.92 5 8.65C17.53 21.5 15.82 22 14 22c-5.52 0-10-4.48-10-10S8.48 2 14 2z"/>
      </svg>
    ),
    medical_services: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 8v11c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h1V4h2v2h4V4h2v2h1c1.1 0 2 .9 2 2zm-8 3v2H9v2h2v2h2v-2h2v-2h-2v-2h-2z"/>
      </svg>
    ),
    emergency: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.79 9.23l-2-3.46c-.09-.16-.26-.26-.44-.26-.18 0-.35.1-.44.26l-2 3.46c-.09.16-.09.36 0 .52l2 3.46c.09.16.26.26.44.26.18 0 .35-.1.44-.26l2-3.46c.09-.16.09-.36 0-.52zM12 2l3.09 6.26L22 12l-6.91 3.74L12 22l-3.09-6.26L2 12l6.91-3.74L12 2zm0 2.44L9.8 8.87l-4.24 2.3 4.24 2.3L12 17.56l2.2-4.43 4.24-2.3-4.24-2.3L12 4.44z"/>
      </svg>
    ),
    local_fire_department: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19.48 12.35c-1.57-4.08-7.16-4.3-5.81-10.23.1-.44-.37-.78-.75-.55C9.29 3.71 6.68 8.93 6.68 13.55c0 4.85 3.95 8.78 8.82 8.78s8.82-3.93 8.82-8.78c0-.67-.07-1.33-.2-1.96-.11-.49-.66-.75-1.06-.42-.4.32-.78.69-1.06 1.18z"/>
      </svg>
    ),
    home_repair_service: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v7c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-7h1c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm2 3h-2V8h2v1zm0 7h-2v-5h2v5z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    smart_toy: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM9 8c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm4 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm2-5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
      </svg>
    ),
    access_time: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const AfterHoursEmergencyCalls = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'business owner'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'business owner' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const emergencyIndustries = [
    {
      name: "Plumbing Services",
      icon: "home_repair_service",
      scenarios: ["Burst pipes", "Flooding emergencies", "No hot water", "Sewer backups"],
      urgency: "Critical - Revenue loss every hour without coverage"
    },
    {
      name: "HVAC Services", 
      icon: "local_fire_department",
      scenarios: ["No heat in winter", "AC failure in summer", "Gas leaks", "Furnace breakdowns"],
      urgency: "Life-threatening - Immediate response required"
    },
    {
      name: "Electrical Services",
      icon: "emergency", 
      scenarios: ["Power outages", "Electrical fires", "Dangerous wiring", "Generator failures"],
      urgency: "Safety hazard - Can't wait until morning"
    },
    {
      name: "Medical Practices",
      icon: "medical_services",
      scenarios: ["Patient emergencies", "Prescription refills", "Urgent appointments", "After-hours questions"],
      urgency: "Patient care - 24/7 availability essential"
    }
  ];

  const afterHoursStats = [
    {
      stat: "35%",
      description: "Of emergency calls happen after 6 PM",
      icon: "nights_stay"
    },
    {
      stat: "68%", 
      description: "Don't call back if they reach voicemail",
      icon: "warning"
    },
    {
      stat: "$400",
      description: "Average emergency service call value", 
      icon: "trending_up"
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "After-Hours Emergency Call Management with AI Receptionist",
    "description": "Never miss emergency calls again. AI receptionist handles after-hours calls 24/7, qualifying emergencies and dispatching urgent requests immediately.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization", 
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="After-Hours Emergency Call Management - 24/7 AI Phone Answering"
        description="Never miss emergency calls with 24/7 AI receptionist. Handles after-hours calls, qualifies emergencies, and dispatches urgent requests immediately."
        keywords="after hours emergency calls, 24/7 phone answering, emergency call management, after hours phone service, emergency ai receptionist"
        canonical="https://receptioneer.ai/after-hours-emergency-calls"
        ogTitle="After-Hours Emergency Call Management - Never Miss Emergency Calls"
        ogDescription="24/7 AI receptionist handles emergency calls when you're closed. Qualifies urgency and dispatches true emergencies immediately."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-red-900 via-red-800 to-orange-700 text-white py-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
              After-Hours
              <br />
              <span className="text-orange-200">Emergency Calls</span>
            </h1>
            
            <p className="text-xl text-orange-100 mb-12 leading-relaxed max-w-3xl mx-auto">
              Never miss another emergency call. Our AI receptionist works 24/7 to handle urgent requests, qualify emergencies, and dispatch you when it truly matters.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="bg-white text-red-900 hover:bg-red-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get 24/7 Coverage →
              </button>
              
              <a
                href="tel:+17863845350"
                className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-red-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
              >
                <MaterialIcon name="phone" className="w-5 h-5" />
                Test Emergency Call
              </a>
            </div>

            <div className="bg-white/10 rounded-2xl p-6 max-w-2xl mx-auto">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-orange-200 text-sm">Coverage</div>
                </div>
                <div>
                  <div className="text-2xl font-black text-white">$0</div>
                  <div className="text-orange-200 text-sm">Missed Calls</div>
                </div>
                <div>
                  <div className="text-2xl font-black text-white">Instant</div>
                  <div className="text-orange-200 text-sm">Dispatch</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* The Problem */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              The After-Hours <span className="text-red-600">Problem</span>
            </h2>
            
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {afterHoursStats.map((item, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 text-center shadow-lg">
                  <MaterialIcon name={item.icon} className="w-12 h-12 text-red-600 mx-auto mb-4" />
                  <div className="text-4xl font-black text-red-600 mb-4">{item.stat}</div>
                  <div className="text-gray-700 font-semibold">{item.description}</div>
                </div>
              ))}
            </div>

            <div className="bg-red-50 border-2 border-red-200 rounded-3xl p-8">
              <h3 className="text-2xl font-black text-red-900 mb-6 text-center">What Happens When You're Closed?</h3>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold text-red-800">Emergency calls go to voicemail</div>
                      <div className="text-red-600 text-sm">Customers in crisis get no immediate help</div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold text-red-800">Lost revenue opportunities</div>
                      <div className="text-red-600 text-sm">High-value emergency calls missed forever</div>
                    </div>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold text-red-800">Competitors get the business</div>
                      <div className="text-red-600 text-sm">Customers call the next available provider</div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold text-red-800">Reputation damage</div>
                      <div className="text-red-600 text-sm">Bad reviews: "They weren't there when I needed them"</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Emergency Industries */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Industries That Need <span className="text-blue-900">24/7 Coverage</span>
            </h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              {emergencyIndustries.map((industry, index) => (
                <div key={index} className="bg-gray-50 rounded-3xl p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name={industry.icon} className="w-8 h-8 text-blue-600" />
                    <h3 className="text-xl font-black text-gray-900">{industry.name}</h3>
                  </div>
                  
                  <div className="mb-6">
                    <div className="font-bold text-gray-900 mb-3">Common After-Hours Emergencies:</div>
                    <ul className="space-y-2">
                      {industry.scenarios.map((scenario, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <MaterialIcon name="emergency" className="w-4 h-4 text-red-500 flex-shrink-0 mt-1" />
                          <span className="text-gray-700">{scenario}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="bg-red-100 rounded-xl p-4">
                    <div className="font-bold text-red-800 text-sm mb-1">Business Impact:</div>
                    <div className="text-red-700 text-sm">{industry.urgency}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* AI Solution */}
        <section className="py-16 px-6 bg-blue-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              AI Emergency <span className="text-blue-900">Management</span>
            </h2>
            
            <div className="bg-white rounded-3xl p-8 shadow-lg mb-8">
              <div className="flex items-center gap-3 mb-6">
                <MaterialIcon name="smart_toy" className="w-8 h-8 text-blue-600" />
                <h3 className="text-2xl font-black text-gray-900">How Our AI Handles Emergencies</h3>
              </div>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="bg-blue-100 rounded-2xl p-6 mb-4">
                    <MaterialIcon name="phone" className="w-12 h-12 text-blue-600 mx-auto" />
                  </div>
                  <div className="font-bold text-gray-900 mb-2">1. Instant Answer</div>
                  <div className="text-gray-600 text-sm">Picks up every call immediately, never goes to voicemail</div>
                </div>
                
                <div className="text-center">
                  <div className="bg-blue-100 rounded-2xl p-6 mb-4">
                    <MaterialIcon name="emergency" className="w-12 h-12 text-blue-600 mx-auto" />
                  </div>
                  <div className="font-bold text-gray-900 mb-2">2. Emergency Screening</div>
                  <div className="text-gray-600 text-sm">Asks qualifying questions to identify true emergencies</div>
                </div>
                
                <div className="text-center">
                  <div className="bg-blue-100 rounded-2xl p-6 mb-4">
                    <MaterialIcon name="access_time" className="w-12 h-12 text-blue-600 mx-auto" />
                  </div>
                  <div className="font-bold text-gray-900 mb-2">3. Immediate Dispatch</div>
                  <div className="text-gray-600 text-sm">Instantly contacts you for real emergencies via call/text</div>
                </div>
              </div>
            </div>

            <div className="bg-green-50 border-2 border-green-200 rounded-3xl p-8">
              <h3 className="text-xl font-black text-green-900 mb-4">Emergency Call Script Example:</h3>
              
              <div className="bg-white rounded-xl p-6">
                <div className="space-y-4 text-sm">
                  <div>
                    <span className="font-bold text-blue-600">AI:</span> 
                    <span className="text-gray-700"> "Thank you for calling [Business Name]. I understand you may have an emergency. Can you tell me what's happening?"</span>
                  </div>
                  
                  <div>
                    <span className="font-bold text-gray-600">Customer:</span>
                    <span className="text-gray-700"> "My basement is flooding and water is everywhere!"</span>
                  </div>
                  
                  <div>
                    <span className="font-bold text-blue-600">AI:</span>
                    <span className="text-gray-700"> "I'm sorry to hear about the flooding. This sounds like an emergency. I'm connecting you with our emergency technician right now and sending them your information."</span>
                  </div>
                  
                  <div className="bg-green-100 rounded-lg p-3">
                    <span className="font-bold text-green-800">Result:</span>
                    <span className="text-green-700"> Technician receives instant call + text with customer details and emergency description</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-16 px-6 bg-gray-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              24/7 Coverage <span className="text-blue-900">Benefits</span>
            </h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="trending_up" className="w-8 h-8 text-green-600" />
                  <h3 className="text-xl font-black text-gray-900">Revenue Benefits</h3>
                </div>
                
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">Capture 100% of emergency calls</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">Higher-value emergency services</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">Beat competitors to the call</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">Build reputation for reliability</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="schedule" className="w-8 h-8 text-blue-600" />
                  <h3 className="text-xl font-black text-gray-900">Operational Benefits</h3>
                </div>
                
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">No more missed emergency calls</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">Intelligent emergency screening</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">Instant technician notification</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
                    <span className="text-gray-700">Professional emergency response</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 px-6 bg-blue-900 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              Never Miss Another Emergency
            </h2>
            
            <p className="text-xl text-blue-100 mb-12">
              Your AI receptionist is standing by 24/7 to handle emergency calls, qualify urgency, and dispatch you when it matters most.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="grid md:grid-cols-3 gap-6 text-center mb-8">
                <div>
                  <div className="text-3xl font-black mb-2">24/7</div>
                  <div className="text-blue-200">Emergency coverage</div>
                </div>
                <div>
                  <div className="text-3xl font-black mb-2">Instant</div>
                  <div className="text-blue-200">Dispatch alerts</div>
                </div>
                <div>
                  <div className="text-3xl font-black mb-2">$399</div>
                  <div className="text-blue-200">per month</div>
                </div>
              </div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-blue-900 hover:bg-blue-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get 24/7 Emergency Coverage →
              </button>
            </div>
            
            <p className="text-blue-200">Ready in 24 hours • Cancel anytime • Every emergency captured</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get 24/7 Emergency Coverage"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're covered!</h3>
              <p className="text-gray-600">Your 24/7 AI emergency receptionist will be ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Sarah Johnson"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="sarah@business.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Coverage...' : 'Get Emergency Coverage'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/after-hours-emergency-calls" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AfterHoursEmergencyCalls;